import React, { Component } from "react";
import ViewPricePlan from "./ViewPricePlan";
import AddPricePlan from "./AddPricePlan";
import setTitle from "../../helpers/TitleComponent";
import { getCookie } from "../../helpers/cookieHelper";

export default class PricePlan extends Component {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.OnEditClick = this.OnEditClick.bind(this);
    this.onSelectionChange = this.onSelectionChange.bind(this);
    this.formClear = this.formClear.bind(this);
    this.childRef = React.createRef();
    this.state = {
      user: {
        planName: "",
        basicInstallationChargeWeb: "",
        basicInstallationChargeWebAndMobile: "",
        basicRenewChargeWeb: "",
        basicRenewChargeWebAndMobile: "",
        basicMaxUsers: "",
        perUserRateWeb: "",
        perUserRateWebAndMobile: "",
        perScreenRateWeb: "",
        perScreenRateWebAndMobile: "",
        number: "",
        renewType: "day",
        enabled: true,
      },
      enabled: [
        { value: true, text: "Active" },
        { value: false, text: "Inactive" },
      ],
      rules: {
        planName: ["required"],
        basicInstallationChargeWeb: {
          required: true,
          positiveNumber: {
            validator(value) {
              return value >= 0;
            },
            message: "This field should be a postive number",
          },
        },
        basicInstallationChargeWebAndMobile: {
          required: true,
          positiveNumber: {
            validator(value) {
              return value >= 0;
            },
            message: "This field should be a postive number",
          },
        },
        basicRenewChargeWeb: {
          required: true,
          positiveNumber: {
            validator(value) {
              return value >= 0;
            },
            message: "This field should be a postive number",
          },
        },
        basicRenewChargeWebAndMobile: {
          required: true,
          positiveNumber: {
            validator(value) {
              return value >= 0;
            },
            message: "This field should be a postive number",
          },
        },
        basicMaxUsers: {
          required: true,
          positiveNumber: {
            validator(value) {
              return value >= 0;
            },
            message: "This field should be a postive number",
          },
        },
        perUserRateWeb: {
          required: true,
          positiveNumber: {
            validator(value) {
              return value >= 0;
            },
            message: "This field should be a postive number",
          },
        },
        perUserRateWebAndMobile: {
          required: true,
          positiveNumber: {
            validator(value) {
              return value >= 0;
            },
            message: "This field should be a postive number",
          },
        },
        perScreenRateWeb: {
          required: true,
          positiveNumber: {
            validator(value) {
              return value >= 0;
            },
            message: "This field should be a postive number",
          },
        },
        perScreenRateWebAndMobile: {
          required: true,
          positiveNumber: {
            validator(value) {
              return value >= 0;
            },
            message: "This field should be a postive number",
          },
        },
        renewType: ["required"],
        number: ["required"],
      },
      operation: "Add",
      selected: {},
      permissions: [],
    };
  }

  refresh() {}

  componentDidMount() {
    var data = getCookie("permission");

    this.setState(
      {
        permissions: JSON.parse(data),
      },
      function () {
        setTitle("Price Plan");
      }
    );
  }

  OnEditClick() {
    if (this.state.selected != null) {
      this.setState(
        {
          user: this.state.selected,
        },
        function () {
          this.childRef.current.validate((errors) => {});
        }
      );
    }
  }

  onSelectionChange(selectedRow) {
    this.setState({
      selected: selectedRow,
      operation: "Update",
    });
  }

  formClear() {
    var user = {
      planName: null,
      basicInstallationChargeWeb: null,
      basicInstallationChargeWebAndMobile: null,
      basicRenewChargeWeb: null,
      basicRenewChargeWebAndMobile: null,
      basicMaxUsers: null,
      perUserRateWeb: null,
      perUserRateWebAndMobile: null,
      perScreenRateWeb: null,
      perScreenRateWebAndMobile: null,
      renewType: null,
      allowedPlatforms: null,
      enabled: true,
    };
    this.setState(
      {
        user: user,
      },
      function () {
        this.childRef.current.validate((errors) => {});
      }
    );
  }

  handleChange(name, value) {
    let user = Object.assign({}, this.state.user);
    //console.log(name);
    //console.log(value);
    user[name] = value;
    this.setState({ user: user });
  }
  render() {
    var permissions = this.state.permissions;

    return (
      <div className='container-fluid'>
        <div className='row'>
          {permissions.includes("price-plan-create") ? (
            <div className='col-5 '>
              <AddPricePlan
                userFields={this.state.user}
                validationRules={this.state.rules}
                handleChange={this.handleChange}
                operation={this.state.operation}
                ref={this.childRef}
                formClear={this.formClear}
                enabled={this.state.enabled}
              />
            </div>
          ) : (
            ""
          )}
          {permissions.includes("price-plan-view") ? (
            <div className='col-7 '>
              <ViewPricePlan
                selectedRow={this.state.selected}
                OnEditClick={this.OnEditClick}
                onSelectionChange={this.onSelectionChange}
                permissions={permissions}
                enabled={this.state.enabled}
              />
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}
